import { BASE_URL } from "@utils/constants";
import {
  addAssignedProjects as addAssignedProjectsAdmin,
  addAssignedFolders as addAssignedFoldersAdmin,
  addAssignedFiles as addAssignedFilesAdmin,
  addValidatorsByLanguage,
  setSelectedFileTargetLanguageId,
  setDevnagariUsers,
  setSentences,
} from "@store/slices/devnagriValidatorAdminSlice";
import {
  addAssignedProjects as addAssignedProjectsUser,
  addAssignedFolders as addAssignedFoldersUser,
  addAssignedFiles as addAssignedFilesUser,
  setTargetLanguageId,
} from "@store/slices/devnagriValidatorSlice";
import apiClient from "@/services/api/apiClient";

export const fetchAllInProgressProjects = (keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  console.log("THUNK CALLED");
  const state = getState();
  const { role, token, userId } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  const requestOptions = { headers: myHeaders,credentials: "include"};
  try {
    let url;
    switch (role) {
      case "DEVANAGARI ADMIN":
        url = `api/devAdmin/projects?devAdminId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
        break;
      case "DEVANAGARI USER":
        url = `api/devUser/projects?devUserId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
        break;
    }
    const result = await apiClient(BASE_URL + url, requestOptions);
    console.log("API RESULT", result);
    const data = result.data || result;
    console.log("DISPATCHING addAssignedProjects", data);
    
    // Ensure data is always an array
    const projectsData = Array.isArray(data) ? data : [];
    
    if (role === "DEVANAGARI ADMIN") {
      dispatch(addAssignedProjectsAdmin(projectsData));
    } else if (role === "DEVANAGARI USER") {
      dispatch(addAssignedProjectsUser(projectsData));
    }
    return projectsData;
  } catch (error) {
    console.error("Error fetching projects:", error);
    // Set empty array on error to prevent undefined issues
    const emptyProjects = [];
    if (role === "DEVANAGARI ADMIN") {
      dispatch(addAssignedProjectsAdmin(emptyProjects));
    } else if (role === "DEVANAGARI USER") {
      dispatch(addAssignedProjectsUser(emptyProjects));
    }
    return emptyProjects;
  }
};

// getInProgressFoldersByProject
export const fetchInProgressFolders =
  (projectId,keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
    const state = getState();
    const { role, token, userId } = state.auth;
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      headers: myHeaders,
      credentials: "include",
    };
    try {
      let url;
      switch (role) {
        case "DEVANAGARI ADMIN":
          url = `api/devAdmin/folders?projectId=${projectId}&devAdminId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
          break;
        case "DEVANAGARI USER":
          url = `api/devUser/folders?projectId=${projectId}&devUserId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
          break;
      }
      const result = await apiClient(BASE_URL + url, requestOptions);
      const data = result.data || result;
      
      // Ensure data is always an array
      const foldersData = Array.isArray(data) ? data : [];
      
      if (role === "DEVANAGARI ADMIN") {
        dispatch(addAssignedFoldersAdmin({ projectId, folders: foldersData }));
      } else if (role === "DEVANAGARI USER") {
        dispatch(addAssignedFoldersUser({ projectId, folders: foldersData }));
      }
      return foldersData;
    } catch (error) {
      console.error("Error fetching folders:", error);
      // Set empty array on error to prevent undefined issues
      const emptyFolders = [];
      if (role === "DEVANAGARI ADMIN") {
        dispatch(addAssignedFoldersAdmin({ projectId, folders: emptyFolders }));
      } else if (role === "DEVANAGARI USER") {
        dispatch(addAssignedFoldersUser({ projectId, folders: emptyFolders }));
      }
      return emptyFolders;
    }
  };

export const fetchInProgressFiles =
  (folderId,keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
    const state = getState();
    const { role, token, userId } = state.auth;
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      headers: myHeaders,
      credentials: "include",
    };
    try {
      let url;
      switch (role) {
        case "DEVANAGARI ADMIN":
          url = `api/devAdmin/files?folderId=${folderId}&devAdminId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
          break;
        case "DEVANAGARI USER":
          url = `api/devUser/files?folderId=${folderId}&devUserId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
          break;
      }

      console.log("Fetching files with URL:", BASE_URL + url);
      const result = await apiClient(BASE_URL + url, requestOptions);
      console.log("Files API response:", result);
      
      const data = result.data || result;
      console.log("Files data to dispatch:", data);
      
      // Ensure data is always an array
      const filesData = Array.isArray(data) ? data : [];
      
      if (role === "DEVANAGARI ADMIN") {
        dispatch(addAssignedFilesAdmin({ folderId, files: filesData }));
      } else if (role === "DEVANAGARI USER") {
        dispatch(addAssignedFilesUser({ folderId, files: filesData }));
      }
      return filesData;
    } catch (error) {
      console.error("Error fetching files:", error);
      // Set empty array on error to prevent undefined issues
      const emptyFiles = [];
      if (role === "DEVANAGARI ADMIN") {
        dispatch(addAssignedFilesAdmin({ folderId, files: emptyFiles }));
      } else if (role === "DEVANAGARI USER") {
        dispatch(addAssignedFilesUser({ folderId, files: emptyFiles }));
      }
      return emptyFiles;
    }
  };

export const fetchValidatorsByLanguage = (languageId) => async (dispatch, getState) => {
  const state = getState();
  const { token,userId } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  const requestOptions = {
    headers: myHeaders,
    credentials: "include",
  };
  
  try {
    const url = `api/devAdmin/getDU?languageId=${languageId}&devAdminId=${userId}`;
    console.log("Fetching validators with URL:", BASE_URL + url);
    
    const result = await apiClient(BASE_URL + url, requestOptions);
    console.log("Validators API response:", result);
    
    if (result.status === "success" && result.data) {
      console.log("Dispatching validators to Redux:", { languageId, validators: result.data });
      dispatch(addValidatorsByLanguage({ languageId, validators: result.data }));
      return result.data;
    } else {
      console.error("Failed to fetch validators:", result);
      return [];
    }
  } catch (error) {
    console.error("Error fetching validators by language:", error);
    return [];
  }
};

export const assignValidatorToFile = (fileId, targetLanguageId, validatorUserId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);
  
  const requestBody = {
    fileId: fileId,
    sourceLanguageId: 2, // Default value as specified
    targetLanguageId: targetLanguageId,
    devUserId: validatorUserId
  };
  
  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    credentials: "include",
    body: JSON.stringify(requestBody),
  };
  
  try {
    const url = `api/devAdmin/assignDU?devAdminId=${userId}`;
    console.log("Assigning validator with URL:", BASE_URL + url);
    console.log("Request body:", requestBody);
    
    const result = await apiClient(BASE_URL + url, requestOptions);
    console.log("Assign validator API response:", result);
    
    if (result.status === "success") {
      return { success: true, message: result.message };
    } else {
      console.error("Failed to assign validator:", result);
      return { success: false, message: result.message || "Failed to assign validator" };
    }
  } catch (error) {
    console.error("Error assigning validator:", error);
    return { success: false, message: "Network error occurred" };
  }
};

// Fetch sentences by file ID for devnagri validator user
export const fetchSentencesByFileId = (fileId, devUserId, sourceLangId, targetLangId,clickReject) => async (dispatch, getState) => {
  const state = getState();
  const { token } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  const requestOptions = {
    headers: myHeaders,
    credentials: "include",
  };
  
  try {
    const url=clickReject?`api/devUser/rejectedSentences?fileId=${fileId}&devUserId=${devUserId}&sourceLangId=${sourceLangId}&targetLangId=${targetLangId}`
    :`api/devUser/approvedSentences?fileId=${fileId}&devUserId=${devUserId}&sourceLangId=${sourceLangId}&targetLangId=${targetLangId}`
    console.log("Fetching sentences with URL:", BASE_URL + url);
    
    const result = await apiClient(BASE_URL + url, requestOptions);
    console.log("Sentences API response:", result);
    
    if (result.status === "success" && Array.isArray(result.data)) {
      return result.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching sentences:", error);
    throw error;
  }
};

export const fetchSentencesByFileIdDA = (fileId, devAdminId, sourceLangId, targetLangId,clickReject) => async (dispatch, getState) => {
  const state = getState();
  const { token } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  const requestOptions = {
    headers: myHeaders,
    credentials: "include",
  };
  
  try {
    const url =clickReject?`api/devAdmin/rejectedSentences?fileId=${fileId}&sourceId=${sourceLangId}&targetId=${targetLangId}&devAdminId=${devAdminId}`: `api/devAdmin/approvedSentences?fileId=${fileId}&sourceId=2&targetId=${targetLangId}&devAdminId=${devAdminId}`;
    console.log("Fetching sentences with URL:", BASE_URL + url);
    
    const result = await apiClient(BASE_URL + url, requestOptions);
    console.log("Sentences API response:", result);
    
    if (result.status === "success" && Array.isArray(result.data)) {
      dispatch(setSentences(result.data));
      return result.data;
    }
    dispatch(setSentences([]));
    return [];
  } catch (error) {
    console.error("Error fetching sentences:", error);
    dispatch(setSentences([]));
    throw error;
  }
};


// Fetch sentences by file ID for devnagri validator admin
export const fetchSentencesByFileIdAdmin = (fileId) => async (dispatch, getState) => {
  const state = getState();
  const { token } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  const requestOptions = {
    headers: myHeaders,
    credentials: "include",
  };
  
  try {
    const url = `api/devAdmin/sentences?fileId=${fileId}`;
    console.log("Fetching sentences for admin with URL:", BASE_URL + url);
    
    const result = await apiClient(BASE_URL + url, requestOptions);
    console.log("Sentences API response:", result);
    
    if (Array.isArray(result) && result.length > 0) {
      // Store the targetLanguageId from the first sentence
      const targetLanguageId = result[0].targetLanguageId;
      dispatch(setTargetLanguageId(targetLanguageId));
      console.log("Stored targetLanguageId:", targetLanguageId);
    }
    
    return result;
  } catch (error) {
    console.error("Error fetching sentences:", error);
    throw error;
  }
};

// Mark validation as completed for devnagri validator user
export const markValidationCompleted = (fileId, sourceLanguageId, targetLanguageId, validatorUserId) => async (dispatch, getState) => {
  const state = getState();
  const { token } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  
  const requestBody = {
    sourceLanguageId: sourceLanguageId,
    fileId: fileId,
    targetLanguageId: targetLanguageId,
    validatorUserId: validatorUserId
  };
  
  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    credentials: "include",
    body: JSON.stringify(requestBody),
  };
  
  try {
    const url = `api/devUser/mark-validation-completed`;
    console.log("Marking validation completed with URL:", BASE_URL + url);
    console.log("Request body:", requestBody);
    
    const result = await apiClient(BASE_URL + url, requestOptions);
    console.log("Mark validation completed API response:", result);
    
    if (result.status === "success") {
      return { success: true, message: result.message };
    } else {
      console.error("Failed to mark validation as completed:", result);
      return { success: false, message: result.message || "Failed to mark validation as completed" };
    }
  } catch (error) {
    console.error("Error marking validation as completed:", error);
    return { success: false, message: "Network error occurred" };
  }
};

export const fetchAllDevnagariUsers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    console.log("Fetching all devnagari users...");
    const data = await apiClient(
      `${BASE_URL}api/devAdmin/active`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    console.log("API Response:", data);
    if (data.status === 'success') {
      console.log("Dispatching users to Redux:", data.data);
      dispatch(setDevnagariUsers(data.data));
    } else {
      console.log("API returned error status, dispatching empty array");
      dispatch(setDevnagariUsers([]));
    }
    return data;
  } catch (error) {
    console.error("Error fetching devnagari users:", error);
    dispatch(setDevnagariUsers([]));
    throw error;
  }
};

export const fetchPendingDevnagariUsers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const data = await apiClient(
      `${BASE_URL}api/devAdmin/pending`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',

          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    if (data.status === 'success') {
      dispatch(setDevnagariUsers(data.data));
    } else {
      dispatch(setDevnagariUsers([]));
    }
    return data;
  } catch (error) {
    dispatch(setDevnagariUsers([]));
    throw error;
  }
};

export const fetchSuspendedDevnagariUsers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const data = await apiClient(
      `${BASE_URL}api/devAdmin/suspend`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    if (data.status === 'success') {
      dispatch(setDevnagariUsers(data.data));
    } else {
      dispatch(setDevnagariUsers([]));
    }
    return data;
  } catch (error) {
    dispatch(setDevnagariUsers([]));
    throw error;
  }
};

export const activateDevnagariUser = (userId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const {token} = state.auth;
    const data = await apiClient(
      `${BASE_URL}api/devAdmin/activate?devUserId=${userId}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    if (data.status === 'success') {
      // Refresh the user list after activation
      dispatch(fetchPendingDevnagariUsers());
      return { success: true, message: "User activated successfully" };
    } else {
      return { success: false, message: data.message || "Failed to activate user" };
    }
  } catch (error) {
    console.error("Error activating user:", error);
    return { success: false, message: "Network error occurred" };
  }
};

export const suspendDevnagariUser = (userId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const {token} = state.auth;
    const data = await apiClient(
      `${BASE_URL}api/devAdmin/suspend?devUserId=${userId}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    if (data.status === 'success') {
      // Refresh the user list after suspension
      dispatch(fetchAllDevnagariUsers());
      return { success: true, message: "User suspended successfully" };
    } else {
      return { success: false, message: data.message || "Failed to suspend user" };
    }
  } catch (error) {
    console.error("Error suspending user:", error);
    return { success: false, message: "Network error occurred" };
  }
};


export const sendToCDAC=(fileId, sourceId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { token } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);
  
  const requestBody = {
    fileId: fileId,
    sourceLanguageId: sourceId,
    targetLanguageId: targetId,
  };
  
  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(requestBody),
    credentials: "include",
  };
  
  try {
    const url = `api/devAdmin/sendToCdac`;
    console.log("Sending to CDAC with URL:", BASE_URL + url);
    
    const result = await apiClient(BASE_URL + url, requestOptions);
    console.log("Send to CDAC API response:", result);
    
    if (result.status === "success") {  
      return { success: true, message: result.message };
    } else {
      console.error("Failed to send to CDAC:", result);
      return { success: false, message: result.message || "Failed to send to CDAC" };
    }
  } catch (error) {
    console.error("Error sending to CDAC:", error);
    return { success: false, message: "Network error occurred" };
  }
}
